import makeApi from '@/common/API';

const api = makeApi(() => window.env.BILLING.API_URL);

export default api;
